import logo from '@assets/givzgreen.svg';
import { NavItemProps } from '@components/ui/nav/nav-item';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import LineAxisSharpIcon from '@mui/icons-material/LineAxisSharp';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCuratedCollection } from '@queries/collections';
import { routes } from '@routes';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './header';
import { Nav } from './nav';

const headerMobileMinHeight = 64;
const headerDesktopMinHeight = 92;
const navWidth = 280;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  minHeight: '100%',
  overflow: 'auto',
  paddingBottom: theme.spacing(10),
  paddingTop: headerMobileMinHeight + 24,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: headerDesktopMinHeight + 24,
  },
}));

const StyledLogo = styled('img')`
  width: 100px;
`;

const items: NavItemProps[] = [
  {
    icon: <DashboardSharpIcon />,
    path: routes.dashboard,
    title: 'dashboard',
  },
  {
    icon: <LineAxisSharpIcon />,
    path: routes.incentives,
    title: 'incentives',
  },
];

const NavHeader = () => {
  return (
    <Stack
      direction="column"
      spacing={1}
      alignItems="start"
      alignSelf="start"
      margin="0"
    >
      <StyledLogo src={logo} />
    </Stack>
  );
};

export default function DashboardLayout() {
  useCuratedCollection();
  const [open, setOpen] = useState(false);

  const onCloseNav = () => setOpen(false);
  const onOpenNav = () => setOpen(true);

  return (
    <StyledRoot>
      <Header
        onOpenNav={onOpenNav}
        desktopMinHeight={headerDesktopMinHeight}
        mobileMinHeight={headerMobileMinHeight}
        navWidth={navWidth}
      />
      <Nav
        openNav={open}
        onCloseNav={onCloseNav}
        items={items}
        width={navWidth}
        header={<NavHeader />}
      />
      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
